const joiWordCountHelper = (value, helpers, wordCount) => {
    const length = value.split(' ').length;
    if (length > wordCount) {
        return helpers.error('length.exceeds');
    }
    return value;
};
export default joiWordCountHelper;
